
import React, { MouseEvent, useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import {useWindowSize} from 'react-use';

import { currentBasicTextFilterPropsAtom, currentFormNameAtom, currentUserSessionAtom, isSearchBoxShowAtom, isSaveLoadingAtom } from 'library/store';

import useUtils from 'library/utils';

import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { makeStyles } from '@mui/material';

import { useTheme } from '@mui/material/styles';


import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!

import timeGridPlugin from '@fullcalendar/timegrid';
import frLocale from '@fullcalendar/core/locales/fr';
import enLocale from '@fullcalendar/core/locales/en-gb'

import interactionPlugin from '@fullcalendar/interaction';



import { flexBetween, flexBetweenCenter, flexCenter, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import useTeacherService, { useBasicFilterTeacher } from './services/Teacher';
import useSchoolYearService, { useBasicFilterSchoolYear } from 'features/setup/services/SchoolYear';

import { ITeacher, defaultTeacher } from './models/Teacher';

import { ISchoolYear} from 'features/setup/models/SchoolYear';

import { BasicTextFilterForm, defaultBasicTextFilterProps } from 'components/ui/BasicTextFilterForm';

import useEntityService, { useBasicFilterEntity } from 'features/services/Entity';

// import WidgetSummary from './widgets/WidgetSummary';
// import WidgetBarChart from './widgets/WidgetBarChart';
// import WidgetPieChart from './widgets/WidgetPieChart';
import { Button } from '@mui/material';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { FormDialog } from 'components/ui/FormDialog';
import { EventInput } from '@fullcalendar/core';
import { isFalsy } from 'utility-types';

import {parse, format} from 'date-fns';


export const TeacherTimeTableForm = () => {

  const theme = useTheme();

  const { t, i18n } = useTranslation();

  const {generateDistinctColorFromName, toDateWithoutSeconds} = useUtils();

  const [currentFormName, setCurrentFormName] = useRecoilState(currentFormNameAtom);
  const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);

  const {language: lg, schoolYears, applicationSetup} = useRecoilValue(currentUserSessionAtom);
  

  const {height, width} = useWindowSize();

  const { getSchoolYearClassTimeTable, getSchoolYearTimeSlots} = useSchoolYearService();

  const { getActiveTeacherTimeTable} = useTeacherService();

  const {retrieveEntity, retrieveData, openEntityActionDrawer, openEntityPrintDrawer, openEntityPrintDrawerEx,
          checkEntityExpressionSyntax, checkEntitySaveAuthorization, hasEntityAuthorization } = useEntityService();
  
  const [schoolYearId, setSchoolYearId] = useState<number>(applicationSetup.currentSchoolYearId);
  const [schoolYearName, setSchoolYearName] = useState('');
  
  const [teacherId, setTeacherId] = useState<number>(-1);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const [timetableEvents, setTimetableEvents] = useState<EventInput[]>([]);
  const [colors, setColors] = useState<Record<string, string>>({});

  const [weekStart, setWeekStart] = useState<Date>(new Date());
  const [weekEnd, setWeekEnd] = useState<Date>(new Date());

  const [minTimeStr, setMinTimeStr] = useState<string>("07:00");
  const [maxTimeStr, setMaxTimeStr] = useState<string>("17:00");


  const [openSchoolYearFilter, setOpenSchoolYearFilter] = useState(false);
    const basicFilterSchoolYear = useBasicFilterSchoolYear( 
        async (event: React.MouseEvent<unknown>, row: ISchoolYear) => {
            const {id, name } = row;
  
            setSchoolYearId(id);
            setSchoolYearName(name);
  
            setOpenSchoolYearFilter(false);
        }
    );
  
  
    const handleClickSelectSchoolYear = (event: any) => {
      setOpenSchoolYearFilter(true);
    }

    const handleClickSelectTeacher = (event: any) => {
      setOpenTeacherFilter(true);
    }

  // const [isSearchBoxShow, setIsSearchBoxShow] = useRecoilState(isSearchBoxShowAtom);
  const [currentBasicTextFilterProps, setCurrentBasicTextFilterProps] = useRecoilState(currentBasicTextFilterPropsAtom);
  
  
  const [openTeacherFilter, setOpenTeacherFilter] = useState(false);
  const basicFilterTeacher = useBasicFilterTeacher( 
    async (event: React.MouseEvent<unknown>, row: ITeacher) => {
        setOpenTeacherFilter(false);

        const {id, firstName, lastName} = row;
        setTeacherId(id);
        setFirstName(firstName);     
        setLastName(lastName);         
      }
  );

  const loadSchoolYearClassTimetable = async (schoolYearId: number, teacherId: number ) => {

      setSchoolYearId(schoolYearId);
      setTeacherId(teacherId);

      const arrTimeSlots = await getSchoolYearTimeSlots(schoolYearId);
      const sortedTimeSlots = arrTimeSlots.map(slot => ({
            startTime: toDateWithoutSeconds(slot.startTime),
            endTime: toDateWithoutSeconds(slot.endTime)
            })).sort((a, b) => a.startTime.getTime() - b.startTime.getTime());
            
      const timeTable = await getActiveTeacherTimeTable(schoolYearId, teacherId);

      setMinTimeStr("07:00");
      setMaxTimeStr("17:00");

      const {timetableEvents, weekStart, weekEnd} = timeTable;
      //const colorSet = new Set( timetableEvents.map( ({title, }) => title ));
      const colorMap : Record<string, string> = {};

      for (let i = 0; i < timetableEvents.length; i++) {
        const {title} = timetableEvents[i];
        if(isFalsy(title)) continue;

        if( isFalsy(colorMap[title]))
          colorMap[title] = generateDistinctColorFromName(title);
        
        timetableEvents[i].backgroundColor = colorMap[title];
        timetableEvents[i].textColor = 'black';
      }

      setTimetableEvents(timetableEvents);
      setWeekStart(weekStart);
      setWeekEnd(weekEnd);

      if(sortedTimeSlots.length > 0) {
        setMinTimeStr( format(sortedTimeSlots.at(0)!.startTime, 'HH:mm') );
        setMaxTimeStr( format(sortedTimeSlots.at(-1)!.endTime, 'HH:mm'));
      }
  }

  

  useEffect( () => {        
    setCurrentFormName(t('Time table'));
    setCurrentBasicTextFilterProps(defaultBasicTextFilterProps);
    
    const schoolYear = schoolYears.find(s => s.id === applicationSetup.currentSchoolYearId);
    setSchoolYearName(schoolYear?.name || '');
  }, []);    

  useEffect(() => {
    async function _() {
             
      if(schoolYearId <= 0 || teacherId <= 0) return;

      await loadSchoolYearClassTimetable(schoolYearId, teacherId);
      //const dash = await getSchoolYearDashboard(applicationSetup.currentSchoolYearId);
      //const schoolYear = schoolYears.find(s => s.id === applicationSetup.currentSchoolYearId);
      //setSchoolYearName(schoolYear?.name || '');
      
      //setDashboard(dash);     
    }
    _();
  }, [schoolYearId, teacherId]);
  
  // Custom title component for the header
  const HeaderTitle = () => {
    return <Typography variant="h6">School Timetable</Typography>;
  };

  const renderHeader = (info: any) => {
    return (
      <div>
        {info.date.toLocaleDateString(lg , { weekday: 'long' })}
      </div>
    );
  };

  const englishDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];


  const actionData = async (event: MouseEvent<HTMLButtonElement>) => {
            openEntityActionDrawer('TeacherTimetable', teacherId);
          }
  
  const printData = async (event: MouseEvent<HTMLButtonElement>) => {
        openEntityPrintDrawerEx('TeacherTimetable', 0 , 
            [ {name: 'TeacherId', value: teacherId, dateValue: new Date()},
              {name: 'SchoolYearId', value: schoolYearId, dateValue: new Date()}
            ]);
      }

  const afterAction = async (event: MouseEvent<HTMLButtonElement>) => {    
       // await loadSchoolYearClassTimetable(schoolYearClassId, schoolYearClassName, schoolYearId);      
      //    queryClient.invalidateQueries(['RequestType',currentEntityIdForAction]);        
      //    await retreiveData(currentEntityNameForAction,currentEntityIdForAction, refetch);        
      //    reset(_data);        
      }

  return (
    <Box sx={{ mx: 0.1 }}>
      <Grid container rowSpacing={1} columnSpacing={3}>
        <Grid item xs={12}>
          <Stack flexDirection='column'>
            <Box sx={{ ...justifyCenter, mt: 0.25, mb: 0.25 }} >
              <Button id='btnAction' onClick={actionData} sx={ {display:'none'}}  />  
              <Button id='btnPrint' onClick={printData} sx={ {display:'none'}}  />  
              <Button id='btnAfterAction' onClick={afterAction} sx={ {display:'none'}}  />

              <Button>
                <Typography  variant="h6" id="tableTitle" color="primary" noWrap sx={{...typographyGroupBoxStyling}}>
                  {`:::: ${schoolYearName} :::::`}
                </Typography>
                <Box sx={{ ...justifyCenter, ml: 1 }} >
                  {`${t('Click to change school year')}`}                  
                  <MdOutlineChangeCircle size={24} onClick={handleClickSelectSchoolYear} />
                </Box>  
              </Button>
            </Box>
            <Box sx={{ ...justifyCenter, mt: 0.25, mb: 0.25 }} >
              <Button>
                <Typography  variant="h6" id="tableTitle" color="primary" noWrap sx={{...typographyGroupBoxStyling}}>
                  {` ${t('Time table')} ->  ${t(('Teacher'))} : ${firstName} ${lastName}`}
                </Typography>
                <Box sx={{ ...justifyCenter, ml: 1 }} >
                  {`${t('Click to change teacher')}`}                  
                  <MdOutlineChangeCircle size={24} onClick={handleClickSelectTeacher} />
                </Box>  
              </Button>
            </Box>                        
            <Box sx={{ ...justifyCenter, mt: 0.25, mb: 0.25 }} >
              <div style={{ width: '100%' }}>
                <FullCalendar
                  plugins={[timeGridPlugin]} // {[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  //locales={[frLocale, enLocale]}
                  //locale={lg.startsWith('fr')?frLocale:enLocale}
                  locale={lg}
                  initialView="timeGridWeek"
                  // dayHeaderContent={(args) => {
                  //   const enDayName = englishDayNames[args.date.getDay()];
                  //   return <div>{enDayName}</div>;
                  // }}

                  // headerToolbar={{
                  //   //left: 'prev,next today',
                  //   //center: 'title',
                  //   left: '',
                  //   center: '',
                  //   //right: 'dayGridMonth,timeGridWeek,timeGridDay'
                  //   right: ''
                  // }}
                  headerToolbar={false}
                  //height="700px"
                  initialDate={weekStart} // Set the initial start date of the week view
                  //weekends={false} // Optional: Hide weekends if desired
                  validRange={{ start: weekStart, end: weekEnd }} // Set the valid date range for the week view
                  nowIndicator={true} // Show current time indicator
                  height="auto" // Auto-adjust height to content
                  allDaySlot={false} // Hide all-day slot
                  slotMinTime={minTimeStr}
                  slotMaxTime={maxTimeStr}
                  
                  slotLabelFormat={{
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    //meridiem: false,
                  }} // Set the slotLabelFormat directly to format time on the vertical axis
                  // other props and event data
                  // Custom toolbar rendering function
                                    
                  events={timetableEvents}

                  dayHeaderContent={renderHeader}
                />
              </div>
            </Box>

            { openSchoolYearFilter && <FormDialog open={openSchoolYearFilter} maxWidth='md'
                okText='' cancelText='' title={t('School year')} onCancel={()=> {}} 
                onClose={()=> {setOpenSchoolYearFilter(false);}} onOk={()=> {setOpenSchoolYearFilter(false);}}  >
                    <BasicTextFilterForm<ISchoolYear> {...basicFilterSchoolYear } />
            </FormDialog> }

            { openTeacherFilter && <FormDialog open={openTeacherFilter} maxWidth='md'
                okText='' cancelText='' title={t('Teacher')} onCancel={()=> {}} 
                onClose={()=> {setOpenTeacherFilter(false);}} onOk={()=> {setOpenTeacherFilter(false);}}  >
                    <BasicTextFilterForm<ITeacher> {...basicFilterTeacher } />
            </FormDialog> }
            
          </Stack>
        </Grid>
      </Grid>
      
    </Box>
  )
}
